import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { Storage } from 'react-jhipster';
import { connect } from 'react-redux';

import { setLocale } from './language.reducer';

export interface ILanguageSwitcherProps {
  currentLocale: string;
  languages: any;
  setLocale: Function;
}

export interface ILanguageSwitcherState {
  open: boolean;
}

export class LanguageSwitcher extends React.Component<ILanguageSwitcherProps, ILanguageSwitcherState> {
  state: ILanguageSwitcherState = {
    open: false
  };

  constructor(props) {
    super(props);
    this.handleLocaleChange = this.handleLocaleChange.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  handleLocaleChange(event) {
    const langKey = event.target.value;
    Storage.local.set('locale', langKey);
    this.props.setLocale(langKey);
    window.location.reload();
  }

  toggleDropdown() {
    this.setState({
      open: !this.state.open
    });
  }
  render() {
    const { currentLocale, languages } = this.props;
    const languageNames = {
      en: 'English',
      st: 'Swahili'
    };

    return (
      <Dropdown isOpen={this.state.open} toggle={this.toggleDropdown} className="d-inline-block">
        <DropdownToggle nav caret className="d-flex align-items-center">
          <span className="d-none d-md-inline">{languageNames[currentLocale]}</span>
        </DropdownToggle>
        <DropdownMenu right>
          {Object.keys(languages).map(lang => (
            <DropdownItem key={lang} value={lang} onClick={this.handleLocaleChange} active={currentLocale === lang}>
              {languageNames[lang]}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

const mapStateToProps = state => ({
  currentLocale: state.locale.currentLocale,
  languages: { en: 'English', st: 'Swahili' }
});

const mapDispatchToProps = { setLocale };

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher);
